
import request from '../request';
import qs from 'qs';
// 医疗机构查询筛选
const getReferenceInfo = (data) => {
    return request.post(`/api/wx/auth/getReferenceInfo?${qs.stringify(data)}`, data)
}
// 根据省查找市
const getCityInfo = function (data) {
    return request.post(`/api/wx/auth/getCityInfo?${qs.stringify(data)}`, data)
}
// 医疗机构获取产品信息
const getProductOrgInfo = (data) => {
    return request.post('/api/wx/auth/getProductOrgInfo', data)
}
// 医疗机构搜索记录清除
const deleteHistroyList = (data) => {
    return request.post('/api/wx/auth/deleteHistroyList')
}
// 医疗机构搜索记录
const getSearchHistroyList = (data) => {
    return request.post('/api/wx/auth/getSearchHistroyList')
}
// 获取医疗机构详情
const getProviderDeatil = (data) => {
    return request.post(`/api/visitor/getProviderDeatil?${qs.stringify(data)}`, data)
}
// 获取医疗机构图片列表
const getProviderImageList = (data) => {
    return request.post(`/api/visitor/getProviderImageList?${qs.stringify(data)}`, data)
}
// 获取医疗机构图片地址
const getProviderImage = (data) => {
    return request.post(`/api/visitor/getProviderImage?${qs.stringify(data)}`, data)
}
// 获取科室列表
const getProviderDepartmentList = (data) => {
    return request.post(`/api/wx/auth/getProviderDepartmentList?${qs.stringify(data)}`, data)
}
// 提交预约信息
const submitAppoint =  (data) => {
    return request.post('/api/wx/auth/appointment', data)
}
// 预约信息列表
const appointList = (data) => {
    return request.post(`/api/wx//auth/appointmentList?memberControlNo=${data.memberControlNo}&language=${data.language}`)
}
  
// 获取预约详情的接口
const getAppointDetail = (data) => {
    return request.post(`/api/wx/auth/appointmentDetail?queryno=${data.queryno}&language=${data.language}`)
}
  
// 取消预约信息
const CancelAppoint = (queryno) => {
    return request.post(`/api/wx/auth/appointmentCancel?queryno=${queryno}`)
}
// 查询有医疗机构的城市
const searchCityForProviderList = (data) => {
    return request.post(`/api/wx/searchCityForProviderList`, data)
}
// 查询城市对应医疗机构
const searchProviderListByCity = (data) => {
    return request.post(`/api/wx/searchProviderListByCity`, data)
}
const searchCountryForProviderList = (data) => {
    return request.post('/api/wx/searchCountryForProviderList', data)
}
const searchProviderListByCountry = (data) => {
    return request.post('/api/wx/searchProviderListByCountry', data)
}
// 对象数组
export default {
    getReferenceInfo,
    getProductOrgInfo,
    deleteHistroyList,
    getSearchHistroyList,
    getProviderDeatil,
    getProviderImageList,
    getProviderImage,
    getProviderDepartmentList,
    getCityInfo,
    submitAppoint,
    appointList,
    getAppointDetail,
    CancelAppoint,
    searchCityForProviderList,
    searchProviderListByCity,
    searchCountryForProviderList,
    searchProviderListByCountry
};